import "./Spinner.scss"; 

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="spinner-loading"></div>
        </div>
    )
}

export default Spinner